// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EducationSlideTrowser_TenantSlideConfigFragment = { __typename?: 'TenantSlideConfig', id: string, configType: Types.TenantSlideConfigConfigType, slideIdentifier: string, contentJSON: any, displayName?: string | null, isHidden: boolean, luminaryOrganizationID?: string | null, createdAt: Time, updatedAt: Time, user: { __typename?: 'User', id: string, displayName: string }, updateUser: { __typename?: 'User', id: string, displayName: string } };

export type EducationPageOverrideFragment = { __typename?: 'EffectiveEducationPageOverride', slideIdentifier: string, contentJSON: any, displayName?: string | null, isHidden: boolean, isOrganizationManaged: boolean };

export type CustomEducationPageFragment = { __typename?: 'TenantSlideConfig', id: string, slideIdentifier: string, contentJSON: any, displayName?: string | null, isHidden: boolean, user: { __typename?: 'User', id: string, displayName: string } };

export type GetEducationPagesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetEducationPagesQuery = { __typename?: 'Query', effectiveEducationPageOverrides: Array<(
    { __typename?: 'EffectiveEducationPageOverride' }
    & EducationPageOverrideFragment
  )>, customSlideTemplates: { __typename?: 'TenantSlideConfigConnection', edges?: Array<{ __typename?: 'TenantSlideConfigEdge', node?: (
        { __typename?: 'TenantSlideConfig' }
        & CustomEducationPageFragment
      ) | null } | null> | null } };

export type GetEducationPageEditorQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetEducationPageEditorQuery = { __typename?: 'Query', effectiveEducationPageOverrides: Array<(
    { __typename?: 'EffectiveEducationPageOverride' }
    & EducationPageOverrideFragment
  )>, customSlideTemplates: { __typename?: 'TenantSlideConfigConnection', edges?: Array<{ __typename?: 'TenantSlideConfigEdge', node?: (
        { __typename?: 'TenantSlideConfig' }
        & CustomEducationPageFragment
      ) | null } | null> | null }, ownedEducationPageOverrides: { __typename?: 'TenantSlideConfigConnection', edges?: Array<{ __typename?: 'TenantSlideConfigEdge', node?: (
        { __typename?: 'TenantSlideConfig' }
        & EducationSlideTrowser_TenantSlideConfigFragment
      ) | null } | null> | null } };

export type CreateTenantSlideConfigMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateTenantSlideConfigInput;
}>;


export type CreateTenantSlideConfigMutation = { __typename?: 'Mutation', createTenantSlideConfig: (
    { __typename?: 'TenantSlideConfig' }
    & EducationSlideTrowser_TenantSlideConfigFragment
  ) };

export type UpdateTenantSlideConfigMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateTenantSlideConfigInput;
}>;


export type UpdateTenantSlideConfigMutation = { __typename?: 'Mutation', updateTenantSlideConfig: (
    { __typename?: 'TenantSlideConfig' }
    & EducationSlideTrowser_TenantSlideConfigFragment
  ) };

export type DeleteTenantSlideConfigMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteTenantSlideConfigMutation = { __typename?: 'Mutation', deleteTenantSlideConfig: string };

export type PublishTenantSlideConfigMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type PublishTenantSlideConfigMutation = { __typename?: 'Mutation', publishTenantSlideConfig: { __typename?: 'TenantSlideConfig', id: string } };

export type UnpublishTenantSlideConfigMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type UnpublishTenantSlideConfigMutation = { __typename?: 'Mutation', unpublishTenantSlideConfig: { __typename?: 'TenantSlideConfig', id: string } };

export const Operations = {
  Query: {
    GetEducationPages: 'GetEducationPages' as const,
    GetEducationPageEditor: 'GetEducationPageEditor' as const
  },
  Mutation: {
    CreateTenantSlideConfig: 'CreateTenantSlideConfig' as const,
    UpdateTenantSlideConfig: 'UpdateTenantSlideConfig' as const,
    DeleteTenantSlideConfig: 'DeleteTenantSlideConfig' as const,
    PublishTenantSlideConfig: 'PublishTenantSlideConfig' as const,
    UnpublishTenantSlideConfig: 'UnpublishTenantSlideConfig' as const
  },
  Fragment: {
    EducationSlideTrowser_TenantSlideConfig: 'EducationSlideTrowser_TenantSlideConfig' as const,
    EducationPageOverride: 'EducationPageOverride' as const,
    CustomEducationPage: 'CustomEducationPage' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EducationSlideTrowser_TenantSlideConfigFragmentDoc = gql`
    fragment EducationSlideTrowser_TenantSlideConfig on TenantSlideConfig {
  id
  configType
  slideIdentifier
  contentJSON
  displayName
  isHidden
  luminaryOrganizationID
  createdAt
  updatedAt
  user {
    id
    displayName
  }
  updateUser {
    id
    displayName
  }
}
    `;
export const EducationPageOverrideFragmentDoc = gql`
    fragment EducationPageOverride on EffectiveEducationPageOverride {
  slideIdentifier
  contentJSON
  displayName
  isHidden
  isOrganizationManaged
}
    `;
export const CustomEducationPageFragmentDoc = gql`
    fragment CustomEducationPage on TenantSlideConfig {
  id
  slideIdentifier
  contentJSON
  displayName
  isHidden
  user {
    id
    displayName
  }
}
    `;
export const GetEducationPagesDocument = gql`
    query GetEducationPages {
  effectiveEducationPageOverrides {
    ...EducationPageOverride
  }
  customSlideTemplates: tenantSlideConfigs(
    where: {configType: CUSTOM_SLIDE_TEMPLATE}
  ) {
    edges {
      node {
        ...CustomEducationPage
      }
    }
  }
}
    ${EducationPageOverrideFragmentDoc}
${CustomEducationPageFragmentDoc}`;

/**
 * __useGetEducationPagesQuery__
 *
 * To run a query within a React component, call `useGetEducationPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEducationPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEducationPagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEducationPagesQuery(baseOptions?: Apollo.QueryHookOptions<GetEducationPagesQuery, GetEducationPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEducationPagesQuery, GetEducationPagesQueryVariables>(GetEducationPagesDocument, withFetchPolicyContext(options));
      }
export function useGetEducationPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEducationPagesQuery, GetEducationPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEducationPagesQuery, GetEducationPagesQueryVariables>(GetEducationPagesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetEducationPagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEducationPagesQuery, GetEducationPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEducationPagesQuery, GetEducationPagesQueryVariables>(GetEducationPagesDocument, withFetchPolicyContext(options));
        }
export type GetEducationPagesQueryHookResult = ReturnType<typeof useGetEducationPagesQuery>;
export type GetEducationPagesLazyQueryHookResult = ReturnType<typeof useGetEducationPagesLazyQuery>;
export type GetEducationPagesSuspenseQueryHookResult = ReturnType<typeof useGetEducationPagesSuspenseQuery>;
export type GetEducationPagesQueryResult = Apollo.QueryResult<GetEducationPagesQuery, GetEducationPagesQueryVariables>;
export const GetEducationPageEditorDocument = gql`
    query GetEducationPageEditor {
  effectiveEducationPageOverrides {
    ...EducationPageOverride
  }
  customSlideTemplates: tenantSlideConfigs(
    where: {configType: CUSTOM_SLIDE_TEMPLATE}
  ) {
    edges {
      node {
        ...CustomEducationPage
      }
    }
  }
  ownedEducationPageOverrides: tenantSlideConfigs(
    where: {configType: EDUCATION_SLIDE_OVERRIDE}
  ) {
    edges {
      node {
        ...EducationSlideTrowser_TenantSlideConfig
      }
    }
  }
}
    ${EducationPageOverrideFragmentDoc}
${CustomEducationPageFragmentDoc}
${EducationSlideTrowser_TenantSlideConfigFragmentDoc}`;

/**
 * __useGetEducationPageEditorQuery__
 *
 * To run a query within a React component, call `useGetEducationPageEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEducationPageEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEducationPageEditorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEducationPageEditorQuery(baseOptions?: Apollo.QueryHookOptions<GetEducationPageEditorQuery, GetEducationPageEditorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEducationPageEditorQuery, GetEducationPageEditorQueryVariables>(GetEducationPageEditorDocument, withFetchPolicyContext(options));
      }
export function useGetEducationPageEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEducationPageEditorQuery, GetEducationPageEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEducationPageEditorQuery, GetEducationPageEditorQueryVariables>(GetEducationPageEditorDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetEducationPageEditorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEducationPageEditorQuery, GetEducationPageEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEducationPageEditorQuery, GetEducationPageEditorQueryVariables>(GetEducationPageEditorDocument, withFetchPolicyContext(options));
        }
export type GetEducationPageEditorQueryHookResult = ReturnType<typeof useGetEducationPageEditorQuery>;
export type GetEducationPageEditorLazyQueryHookResult = ReturnType<typeof useGetEducationPageEditorLazyQuery>;
export type GetEducationPageEditorSuspenseQueryHookResult = ReturnType<typeof useGetEducationPageEditorSuspenseQuery>;
export type GetEducationPageEditorQueryResult = Apollo.QueryResult<GetEducationPageEditorQuery, GetEducationPageEditorQueryVariables>;
export const CreateTenantSlideConfigDocument = gql`
    mutation CreateTenantSlideConfig($input: AugmentedCreateTenantSlideConfigInput!) {
  createTenantSlideConfig(input: $input) {
    ...EducationSlideTrowser_TenantSlideConfig
  }
}
    ${EducationSlideTrowser_TenantSlideConfigFragmentDoc}`;
export type CreateTenantSlideConfigMutationFn = Apollo.MutationFunction<CreateTenantSlideConfigMutation, CreateTenantSlideConfigMutationVariables>;

/**
 * __useCreateTenantSlideConfigMutation__
 *
 * To run a mutation, you first call `useCreateTenantSlideConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantSlideConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantSlideConfigMutation, { data, loading, error }] = useCreateTenantSlideConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTenantSlideConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateTenantSlideConfigMutation, CreateTenantSlideConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTenantSlideConfigMutation, CreateTenantSlideConfigMutationVariables>(CreateTenantSlideConfigDocument, options);
      }
export type CreateTenantSlideConfigMutationHookResult = ReturnType<typeof useCreateTenantSlideConfigMutation>;
export type CreateTenantSlideConfigMutationResult = Apollo.MutationResult<CreateTenantSlideConfigMutation>;
export type CreateTenantSlideConfigMutationOptions = Apollo.BaseMutationOptions<CreateTenantSlideConfigMutation, CreateTenantSlideConfigMutationVariables>;
export const UpdateTenantSlideConfigDocument = gql`
    mutation UpdateTenantSlideConfig($input: AugmentedUpdateTenantSlideConfigInput!) {
  updateTenantSlideConfig(input: $input) {
    ...EducationSlideTrowser_TenantSlideConfig
  }
}
    ${EducationSlideTrowser_TenantSlideConfigFragmentDoc}`;
export type UpdateTenantSlideConfigMutationFn = Apollo.MutationFunction<UpdateTenantSlideConfigMutation, UpdateTenantSlideConfigMutationVariables>;

/**
 * __useUpdateTenantSlideConfigMutation__
 *
 * To run a mutation, you first call `useUpdateTenantSlideConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantSlideConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantSlideConfigMutation, { data, loading, error }] = useUpdateTenantSlideConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTenantSlideConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantSlideConfigMutation, UpdateTenantSlideConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantSlideConfigMutation, UpdateTenantSlideConfigMutationVariables>(UpdateTenantSlideConfigDocument, options);
      }
export type UpdateTenantSlideConfigMutationHookResult = ReturnType<typeof useUpdateTenantSlideConfigMutation>;
export type UpdateTenantSlideConfigMutationResult = Apollo.MutationResult<UpdateTenantSlideConfigMutation>;
export type UpdateTenantSlideConfigMutationOptions = Apollo.BaseMutationOptions<UpdateTenantSlideConfigMutation, UpdateTenantSlideConfigMutationVariables>;
export const DeleteTenantSlideConfigDocument = gql`
    mutation DeleteTenantSlideConfig($id: ID!) {
  deleteTenantSlideConfig(id: $id)
}
    `;
export type DeleteTenantSlideConfigMutationFn = Apollo.MutationFunction<DeleteTenantSlideConfigMutation, DeleteTenantSlideConfigMutationVariables>;

/**
 * __useDeleteTenantSlideConfigMutation__
 *
 * To run a mutation, you first call `useDeleteTenantSlideConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenantSlideConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTenantSlideConfigMutation, { data, loading, error }] = useDeleteTenantSlideConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTenantSlideConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTenantSlideConfigMutation, DeleteTenantSlideConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTenantSlideConfigMutation, DeleteTenantSlideConfigMutationVariables>(DeleteTenantSlideConfigDocument, options);
      }
export type DeleteTenantSlideConfigMutationHookResult = ReturnType<typeof useDeleteTenantSlideConfigMutation>;
export type DeleteTenantSlideConfigMutationResult = Apollo.MutationResult<DeleteTenantSlideConfigMutation>;
export type DeleteTenantSlideConfigMutationOptions = Apollo.BaseMutationOptions<DeleteTenantSlideConfigMutation, DeleteTenantSlideConfigMutationVariables>;
export const PublishTenantSlideConfigDocument = gql`
    mutation PublishTenantSlideConfig($id: ID!) {
  publishTenantSlideConfig(id: $id) {
    id
  }
}
    `;
export type PublishTenantSlideConfigMutationFn = Apollo.MutationFunction<PublishTenantSlideConfigMutation, PublishTenantSlideConfigMutationVariables>;

/**
 * __usePublishTenantSlideConfigMutation__
 *
 * To run a mutation, you first call `usePublishTenantSlideConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishTenantSlideConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishTenantSlideConfigMutation, { data, loading, error }] = usePublishTenantSlideConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishTenantSlideConfigMutation(baseOptions?: Apollo.MutationHookOptions<PublishTenantSlideConfigMutation, PublishTenantSlideConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishTenantSlideConfigMutation, PublishTenantSlideConfigMutationVariables>(PublishTenantSlideConfigDocument, options);
      }
export type PublishTenantSlideConfigMutationHookResult = ReturnType<typeof usePublishTenantSlideConfigMutation>;
export type PublishTenantSlideConfigMutationResult = Apollo.MutationResult<PublishTenantSlideConfigMutation>;
export type PublishTenantSlideConfigMutationOptions = Apollo.BaseMutationOptions<PublishTenantSlideConfigMutation, PublishTenantSlideConfigMutationVariables>;
export const UnpublishTenantSlideConfigDocument = gql`
    mutation UnpublishTenantSlideConfig($id: ID!) {
  unpublishTenantSlideConfig(id: $id) {
    id
  }
}
    `;
export type UnpublishTenantSlideConfigMutationFn = Apollo.MutationFunction<UnpublishTenantSlideConfigMutation, UnpublishTenantSlideConfigMutationVariables>;

/**
 * __useUnpublishTenantSlideConfigMutation__
 *
 * To run a mutation, you first call `useUnpublishTenantSlideConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishTenantSlideConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishTenantSlideConfigMutation, { data, loading, error }] = useUnpublishTenantSlideConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnpublishTenantSlideConfigMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishTenantSlideConfigMutation, UnpublishTenantSlideConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishTenantSlideConfigMutation, UnpublishTenantSlideConfigMutationVariables>(UnpublishTenantSlideConfigDocument, options);
      }
export type UnpublishTenantSlideConfigMutationHookResult = ReturnType<typeof useUnpublishTenantSlideConfigMutation>;
export type UnpublishTenantSlideConfigMutationResult = Apollo.MutationResult<UnpublishTenantSlideConfigMutation>;
export type UnpublishTenantSlideConfigMutationOptions = Apollo.BaseMutationOptions<UnpublishTenantSlideConfigMutation, UnpublishTenantSlideConfigMutationVariables>;